// https://www.showdoc.cc/2598839061605610
// h3tTipDZ
// OAL接口文档

const host = '/api/';

export default {
    category: `${host}category`,
    list: `${host}list`,
    detail: `${host}info`,
    login: `${host}login`,
    userinfo: `${host}user-info`,
    courses: `${host}courses`,
    upFile: `${host}file`,
    resetPassword: `${host}reset-password`,
    setInfo: `${host}setting`,
    userFile: `${host}user-file`,
    score: `${host}score`,
}